import React from "react";
import { Select } from "antd";

import { API_BASE_URL } from "../config.js"

const { Option } = Select;

export const getSelectOptionsWithOrWithoutImg = (options, img = 1) => {
  return options.map((option) => {
    return (
      <Option key={option.id} value={option.id} data-searchvalue={option.name}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {img ? (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: "5px",
              }}
            >
              {option.img ? (
                <img
                  src={`${API_BASE_URL}${option.img}`}
                  alt={option.id}
                  style={{
                    maxWidth: "16px",
                    maxHeight: "16px",
                  }}
                />
              ) : (
                ""
              )}
            </span>
          ) : (
            ""
          )}
          {option.name}
        </div>
      </Option>
    );
  });
};
export const getSelectDoctorOptions = (options)=>{ 
  return options.map((option) => {
  return (
    <Option key={option.id} value={option.id}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {option.first_name} {option.last_name}
      </div>
    </Option>
  );
});
};
export const getSelectSpecializationOptions = (options) => {
  return options.map((option) => {
    return (
      <Option key={option.id} value={option.id} data-searchvalue={option.name}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {option.name}
        </div>
      </Option>
    );
  });
};

export const getSelectPatientOptions = (options) => {
  return options.map((option) => {
    return (
      <Option
        key={option.id}
        value={option.id}
        data-searchvalue={
          option.code + " " + option.first_name + " " + option.last_name
        }
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {option.code + " - " + option.first_name + " " + option.last_name}
        </div>
      </Option>
    );
  });
};

export const getSelectOrdinationOptions = (options) => {
  return options.map((option) => {
    return (
      <Option key={option.id} value={option.id}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {option.name}
        </div>
      </Option>
    );
  });
};

export const getSelectReportTypeOptions = (options) => {
  return options.map((option) => {
    return (
      <Option key={option.id} value={option.id} data-searchvalue={option.name}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {option.name} 
        </div>
      </Option>
    );
  });
};
